module.exports = __webpack_public_path__ + "static/media/if_intro-mob.74614c1d.mp4";